{
  "version": 1,
  "_comment": "The doctor public page template manifest (docs/DOCTOR_PUBLIC_PAGE_DESIGN.md §6). BYTE-IDENTICAL in the practitioner service (validation), the doctor client (editor) and the doctorsite web (renderer) — `make doctorpage-manifests-check`. Change one, change all three.",
  "limits": {
    "slug_min": 3,
    "slug_max": 40,
    "display_name_max": 80,
    "headline_max": 160,
    "hero_cards_max": 2,
    "hero_card_title_max": 40,
    "hero_card_text_max": 90,
    "hero_highlights_max": 3,
    "hero_highlight_title_max": 40,
    "hero_highlight_text_max": 60,
    "about_md_max": 8000,
    "title_override_max": 60,
    "service_title_max": 80,
    "service_description_max": 1000,
    "testimonial_text_max": 600,
    "testimonial_attribution_max": 60,
    "video_caption_max": 160,
    "article_title_max": 160,
    "article_body_max": 65536,
    "articles_max": 100,
    "alt_max": 160,
    "phones_max": 4,
    "phone_label_max": 30,
    "phone_number_max": 20,
    "address_max": 300,
    "city_max": 60,
    "hours_max": 7,
    "hours_label_max": 40,
    "hours_value_max": 60,
    "social_max": 200,
    "image_upload_bytes_max": 5242880,
    "booking_services_max": 30,
    "booking_horizon_min": 7,
    "booking_horizon_max": 30,
    "booking_horizon_default": 14
  },
  "sections": {
    "hero":         { "title": "پروفایل حرفه‌ای",       "required": true,  "max_items": 0 },
    "services":     { "title": "خدمات",                 "required": false, "max_items": 12 },
    "articles":     { "title": "مقالات و مطالب علمی",   "required": false, "max_items": 0 },
    "testimonials": { "title": "نظرات منتخب بیماران",   "required": false, "max_items": 10 },
    "gallery":      { "title": "گالری تصاویر",          "required": false, "max_items": 12 },
    "video":        { "title": "ویدیو",                 "required": false, "max_items": 3 },
    "office":       { "title": "اطلاعات مطب",           "required": true,  "max_items": 0 },
    "booking":      { "title": "نوبت‌دهی",              "required": false, "max_items": 1 }
  },
  "default_template": "classic",
  "templates": [
    {
      "id": "classic",
      "name": "کلاسیک",
      "description": "چیدمان متین و پرتره‌محور؛ مناسب معرفی رسمی و حرفه‌ای.",
      "tier": "free",
      "uses_cover": true,
      "sections": ["hero", "services", "articles", "testimonials", "gallery", "video", "office", "booking"],
      "default_order": ["hero", "services", "articles", "testimonials", "gallery", "video", "office", "booking"],
      "palettes": [
        { "id": "azure",    "name": "لاجوردی", "primary": "#0173BE", "primary_dark": "#015E9C", "accent": "#00BEB2", "surface": "#F5F7FA", "ink": "#1A2332" },
        { "id": "teal",     "name": "فیروزه‌ای", "primary": "#007D74", "primary_dark": "#00605A", "accent": "#0173BE", "surface": "#F4F8F8", "ink": "#1A2332" },
        { "id": "deep",     "name": "سرمه‌ای",  "primary": "#0A4F8F", "primary_dark": "#083D6F", "accent": "#00BEB2", "surface": "#F5F7FA", "ink": "#1A2332" }
      ],
      "default_palette": "azure",
      "densities": ["comfortable", "compact"],
      "default_density": "comfortable"
    },
    {
      "id": "modern",
      "name": "مدرن",
      "description": "هیروی تمام‌عرض با تصویر کاور و بخش‌های کارتی؛ پرانرژی و تصویری.",
      "tier": "free",
      "uses_cover": true,
      "sections": ["hero", "services", "articles", "testimonials", "gallery", "video", "office", "booking"],
      "default_order": ["hero", "services", "gallery", "video", "testimonials", "articles", "office", "booking"],
      "palettes": [
        { "id": "brand",    "name": "برند پارسینا", "primary": "#0173BE", "primary_dark": "#083250", "accent": "#00BEB2", "surface": "#FFFFFF", "ink": "#1A2332" },
        { "id": "cyan",     "name": "آبی فیروزه‌ای", "primary": "#007C8C", "primary_dark": "#06363F", "accent": "#00BEB2", "surface": "#FFFFFF", "ink": "#1A2332" },
        { "id": "deep",     "name": "سرمه‌ای",      "primary": "#0A4F8F", "primary_dark": "#062F57", "accent": "#00BEB2", "surface": "#FFFFFF", "ink": "#1A2332" }
      ],
      "default_palette": "brand",
      "densities": ["comfortable", "compact"],
      "default_density": "comfortable"
    },
    {
      "id": "minimal",
      "name": "مینیمال",
      "description": "تایپوگرافیک و خلوت، بدون کاور؛ تمرکز بر متن، خدمات و مقالات.",
      "tier": "free",
      "uses_cover": false,
      "sections": ["hero", "services", "articles", "testimonials", "office", "booking"],
      "default_order": ["hero", "services", "articles", "testimonials", "office", "booking"],
      "palettes": [
        { "id": "ink",      "name": "جوهری",   "primary": "#1A2332", "primary_dark": "#0B1320", "accent": "#0173BE", "surface": "#FFFFFF", "ink": "#1A2332" },
        { "id": "azure",    "name": "لاجوردی", "primary": "#0173BE", "primary_dark": "#015E9C", "accent": "#00BEB2", "surface": "#FFFFFF", "ink": "#1A2332" }
      ],
      "default_palette": "ink",
      "densities": ["comfortable", "compact"],
      "default_density": "comfortable"
    }
  ]
}
